var React = require('react');

function Warning (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#000000","d":"M8 1.45l6.705 13.363h-13.409l6.705-13.363zM8 0c-0.345 0-0.69 0.233-0.951 0.698l-6.829 13.611c-0.523 0.93-0.078 1.691 0.989 1.691h13.583c1.067 0 1.512-0.761 0.989-1.691h0l-6.829-13.611c-0.262-0.465-0.606-0.698-0.951-0.698v0z","key":0}),React.createElement("path",{"fill":"#000000","d":"M9 13c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z","key":1}),React.createElement("path",{"fill":"#000000","d":"M8 11c-0.552 0-1-0.448-1-1v-3c0-0.552 0.448-1 1-1s1 0.448 1 1v3c0 0.552-0.448 1-1 1z","key":2})]);
}

Warning.displayName = "Warning";

Warning.defaultProps = {"version":"1.1","width":"100%","height":"100%","viewBox":"0 0 16 16"};

module.exports = Warning;

Warning.default = Warning;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/svg/warning.svg
// module id = 1672
// module chunks = 0